module.exports = __webpack_public_path__ + "img/5_13.af81536e.png";